import { useCallback } from "react";
import Auth from "../../../Auth";
import { SET_DATA_ACTION } from "./useCanvasReducer";
import { useToast } from "../../ToastWrapper";

export default ({ cards, groups, cardIdsString, groupIdsString, dispatch }) => {
  const { setToast } = useToast();

  /**
   * Generates outline based on header card
   * @param {*} type
   * @param {*} headerCardId
   */
  const generateOutline = useCallback(
    async ({ type, headerCardId }) => {
      let group = null;

      // first find all the outline cards in the group
      for (const groupId of Object.keys(groups)) {
        const g = groups[groupId];

        if (g.cards[0] === headerCardId) {
          group = g;
        }
      }

      if (!group) {
        throw new Error("Couldn't find group " + headerCardId);
      }

      const headerCard = cards[headerCardId];
      const groupCards = group.cards.map((id) => cards[id]);

      if (headerCard.content.trim().length === 0) {
        return setToast("Please fill in a concept for your outline");
      }

      const data = {
        concept: headerCard.content,
        type: headerCard.data.type,
      };

      console.log(data);

      // setCards((draft) => {
      // groupCards.forEach((card) => {
      //   dispatch({ type: SET_DATA_SILENT_ACTION, id: card.id, data: { generating: true } });
      // });
      // });

      let result;
      try {
        result = await Auth.fetchWithIdToken("/api/ai/canvasOutline", data);
      } catch (e) {
        return setToast("Something went wrong with the request. Please try again.");
      }

      result.output.forEach((beat) => {
        // find the associated card
        const outlineCard = groupCards.find((c) => c.data.beatId === beat.id);

        if (!outlineCard) {
          return console.log("missing outline card with beat id: ", beat.id);
        }

        dispatch({ type: SET_DATA_ACTION, id: outlineCard.id, data: { content: beat.content } });
      });

      return true;
    },
    [groupIdsString, cardIdsString, cards, groups]
  );

  return { generateOutline };
};
